import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";


export default /*@__PURE__*/_defineComponent({
  __name: 'AccountLogout',
  props: {
    returnUrl: {}
  },
  setup(__props: any) {

const props = __props;

const localizer = Localizer;
const routes = (window as any).App.routes;

async function logout() {
    localStorage.removeItem("token");

    await Axios.post(routes.Account_User_Logout, null, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } });

    window.location.href = props.returnUrl ? props.returnUrl : "/";
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (logout())),
    class: "button"
  }, [
    _cache[1] || (_cache[1] = _createElementVNode("span", {
      class: "icon fastic-logout",
      "aria-hidden": "true"
    }, null, -1)),
    _createTextVNode(_toDisplayString(_unref(localizer).get("Account.Common.Logout")), 1)
  ]))
}
}

})